export { LatestIssuesCard } from './LatestIssuesCard';
export const issuesPageLoader = () => true;
